export function setQueryParamsObjToString(paramsObj: any, ignoreUndefined: boolean = false): string {
    const result = Object.keys(paramsObj)
        .filter(key => paramsObj[key] !== '' && (ignoreUndefined ? paramsObj[key] !== undefined : true))
        .map(key => `${key}=${paramsObj[key]}`)
        .join('&');

    return result;
}
